import React from 'react';
import styles from './AuthFooter.module.css';

const AuthFooter = () => {
    return (
        <div className={styles.authFooter}>
            
        </div>
    );
};

export default AuthFooter;